// Lib
import gql from 'graphql-tag';

// Types
import { AUTH, SHOPIFY_PRODUCT } from '../types';

export const getProducts = gql`
  query GetProducts($input: ShopifyProductGetInput!) {
    products(input: $input) {
      ${SHOPIFY_PRODUCT}
    }
  }
`;

export const getShopsQuery = gql`
  query Shops {
    shops {
      ${AUTH}
    }
  }
`;
